import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Flex, FormField, Spinner, Text } from "pcln-design-system";
import { ErrorToolTip, FormInput } from "../OtpForm/OtpForm.styles.js";
import { useOtpContext } from "../../context/OtpContext.js";
import { ChatbotDataContext } from "../../context/ChatbotDataContext.js";
import ResentButton from "./ResentButton.js";
const VerificationCode = ()=>{
    const messageEndRef = useRef(null);
    const errorMessage = 'I’m having some trouble accessing your trip information. ';
    const [showVerificationError, setShowVerificationError] = useState(false);
    const [validOtpCode, setValidOtpCode] = useState(false);
    const [smsCode, setSmsCode] = useState();
    const { verificationApiFunction, setOtpRequestErrorMsg, handleOtpSubmit, resendInProgress } = useOtpContext();
    const [otpValidationInProgress, setOtpValidationInProgress] = useState(false);
    const { setAccountLessAccessToken } = useContext(ChatbotDataContext);
    useEffect(()=>{
        messageEndRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    }, []);
    const isSmsCodeValidated = useMemo(()=>smsCode && /^\d{6}$/.test(String(smsCode)), [
        smsCode
    ]);
    const disableButton = useMemo(()=>!(smsCode && isSmsCodeValidated), [
        smsCode,
        isSmsCodeValidated
    ]);
    function handleSmsCodeChange(e) {
        const value = e.currentTarget.value;
        setShowVerificationError(false);
        if (/^\d*$/.test(value) && value.length <= 6) setSmsCode(value);
    }
    async function submitFormHandler(e) {
        e.preventDefault();
        setOtpRequestErrorMsg('');
        setOtpValidationInProgress(true);
        try {
            const verificationResult = await verificationApiFunction(smsCode);
            if (verificationResult.success) {
                setValidOtpCode(true);
                setAccountLessAccessToken(verificationResult.token);
                handleOtpSubmit(verificationResult.token);
            } else setShowVerificationError(true);
        } catch (e) {
            setOtpRequestErrorMsg(errorMessage);
        } finally{
            setOtpValidationInProgress(false);
        }
    }
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            otpValidationInProgress ? /*#__PURE__*/ jsx(Spinner, {}) : validOtpCode ? /*#__PURE__*/ jsx(Text, {
                fontWeight: 'bold',
                children: "Success!"
            }) : resendInProgress ? null : /*#__PURE__*/ jsxs(Box, {
                children: [
                    /*#__PURE__*/ jsx(Flex, {
                        flexDirection: 'column',
                        pb: 2,
                        children: /*#__PURE__*/ jsxs(Box, {
                            children: [
                                showVerificationError ? /*#__PURE__*/ jsx(ErrorToolTip, {
                                    id: "otp-verification-error",
                                    right: true,
                                    top: true,
                                    color: "error",
                                    children: "It looks like that code isn’t working. It may have expired or been entered incorrectly. Please try again."
                                }) : null,
                                /*#__PURE__*/ jsx(FormField, {
                                    children: /*#__PURE__*/ jsx(FormInput, {
                                        id: "code",
                                        name: "phone",
                                        type: "text",
                                        inputMode: "numeric",
                                        pattern: "[0-9]{6}",
                                        maxLength: 6,
                                        placeholder: '6-digit code \u207A',
                                        onChange: handleSmsCodeChange,
                                        value: smsCode
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        children: /*#__PURE__*/ jsx(Button, {
                            disabled: disableButton,
                            onClick: submitFormHandler,
                            children: "Confirm"
                        })
                    })
                ]
            }),
            !otpValidationInProgress && /*#__PURE__*/ jsx(ResentButton, {
                validOtpCode: validOtpCode
            })
        ]
    });
};
const VerificationCode_VerificationCode = VerificationCode;
export { VerificationCode_VerificationCode as default };
